import { Inline, IconSearch, IconClear } from 'braid-design-system';
import queryString from 'query-string';
import React from 'react';

import ExternalLink from 'src/components/ExternalLink/ExternalLink';
import Routes from 'src/config/routes';
import type {
  ClientListingForListingsTab,
  ListingProductForListingsTab,
} from 'src/types/graphql-derived';

import Action from './Action';
import { BoostButton } from './BoostButton';
import { EditAction } from './EditAction';

interface PostedViewProps {
  listing: ClientListingForListingsTab;
  isLus: boolean;
  isFreemium: boolean;
  searchBoostProduct?: ListingProductForListingsTab;
  emailBoostProduct?: ListingProductForListingsTab;
  onEditClick: () => void;
  onExpireClick: () => void;
  onViewClick: () => void;
}

export const PostedView = ({
  listing,
  isLus,
  isFreemium,
  searchBoostProduct,
  emailBoostProduct,
  onEditClick,
  onExpireClick,
  onViewClick,
}: PostedViewProps) => {
  const boostProductsExist = searchBoostProduct && emailBoostProduct;
  const isAlreadyBooosted = listing.isPremium && listing.isListingEmailBoosted;

  return (
    <Inline space="large">
      <ExternalLink
        destination={queryString.stringifyUrl({
          url: Routes.VIEW_AD_URL + listing.id,
          query: {},
        })}
      >
        <Action Icon={IconSearch} action="View" onClick={onViewClick} />
      </ExternalLink>

      <EditAction listing={listing} onClick={onEditClick} />

      <Action Icon={IconClear} action="Remove" onClick={onExpireClick} />

      {!isFreemium && boostProductsExist && !isAlreadyBooosted && (
        <BoostButton
          listing={listing}
          isLus={isLus}
          searchBoostProduct={searchBoostProduct}
          emailBoostProduct={emailBoostProduct}
        />
      )}
    </Inline>
  );
};
